import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import { accentuate } from '../'
import { Section, Heading, Instructions, ExternalLinkBlock } from '../s'
import Paragraph from 'components/typography/paragraph'

const UnimicroHowToUse = ({ data }) => {
    const { formatMessage } = useIntl()

    return (
        <Section>
            <Heading>
                <FormattedMessage
                    id="integration_heading_how_to_use"
                    defaultMessage="How to use" />
            </Heading>
            <Paragraph>
                <FormattedMessage
                    id="integration_preamble_how_to_use"
                    defaultMessage="Get started quickly by following these steps:" />
            </Paragraph>
            <Instructions instructions={[
                {
                    text: formatMessage({
                        id: 'integration_instruction_connect',
                        defaultMessage: 'Click the <accent>Set up</accent> button, and accept Huma’s Terms and Conditions'
                    }, { accent: accentuate })
                },
                {
                    text: formatMessage({
                        id: 'integration_unimicro_instruction_setup',
                        defaultMessage: 'You will be sent to Unimicro and asked to authorize the connection to your Unimicro account'
                    })
                },
                {
                    text: formatMessage({
                        id: 'integration_unimicro_instruction_established',
                        defaultMessage: 'Once a connection is successfully established, updates on users in Huma for the supported fields will be sent to Unimicro'
                    })
                }
            ]} />
            <ExternalLinkBlock href={data.knowledgebaseUrl}>
                <FormattedMessage
                    id="integration_unimicro_link_knowledgebase"
                    defaultMessage="Using the Unimicro integration" />
            </ExternalLinkBlock>
        </Section>
    )
}

export default UnimicroHowToUse